export default "__VITE_ASSET__DIKhg8pX__"